import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";

export default function AboutIntro() {
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="about-intro">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <div className="relative">
              <h2 className="font-display text-4xl font-black uppercase leading-[0.98] tracking-[-0.03em] text-brand-blue sm:text-5xl lg:text-[3.6rem]">
                Choisir Educaser, c'est investir dans son <span className="text-brand-red">avenir</span>
              </h2>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="lg:pt-4">
              <p className="text-lg leading-relaxed text-slate-600">
                Regroupement de centres de formation spécialisé dans les métiers du transport, EDUCASER GROUP
                accompagne conducteurs et futurs enseignants de la conduite vers des qualifications
                reconnues. Nos programmes allient exigence pédagogique, formateurs experts et moyens
                matériels performants et innovants pour votre réussite.
              </p>
              <p className="mt-4 text-sm italic text-slate-400">
                *Centres certifiés Qualiopi, agréés par les autorités compétentes.
              </p>
              <Link
                to="/le-groupe"
                className="group mt-7 inline-flex items-center gap-2 font-display text-base font-extrabold uppercase tracking-tight text-brand-blue underline decoration-brand-red decoration-2 underline-offset-4 hover:text-brand-red"
                data-testid="about-intro-link"
              >
                Découvrir le Groupe
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
